import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class K2SyncService {
  constructor(private http: HttpClient) {}

  initiateSync(pdfEngineApiUrl: string, params: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    return this.http.post<any>(
      `${pdfEngineApiUrl}/initiateSync`,
      urlEncoded.toString(),
      { headers, withCredentials: true }
    );
  }
}
